const mutableProps = [
  'skuId',
  'ssuId',
  'count',
  'selected',
  'hasSubscribed',
  'buySkuNumMsg',
  'statusRemindInfo',
  'promotionRemindInfo',
  'purchasePriceRemindInfo',
  'packages'
]

class Ssu {
  uniqueId = ''
  skuId = ''
  ssuId = ''
  count = 0
  selected = false
  hasSubscribed = false
  buySkuNumMsg = ''
  statusRemindInfo = {}
  promotionRemindInfo = {}
  purchasePriceRemindInfo = {}
  packages = []
  _subscriberIdCounter = 0
  _subscribers = {}
  constructor({
    uniqueId,
    skuId,
    ssuId,
    count,
    selected,
    hasSubscribed = false,
    buySkuNumMsg,
    statusRemindInfo,
    promotionRemindInfo,
    purchasePriceRemindInfo,
    packages
  }) {
    this.uniqueId = uniqueId
    this.skuId = skuId || ''
    this.ssuId = ssuId || ''
    this.count = count || 0
    this.selected = selected !== undefined ? !!selected : false
    this.hasSubscribed = hasSubscribed
    this.buySkuNumMsg = buySkuNumMsg || ''
    this.statusRemindInfo = statusRemindInfo || {}
    this.promotionRemindInfo = promotionRemindInfo || {}
    this.purchasePriceRemindInfo = purchasePriceRemindInfo || {}
    this.packages = packages || []
  }

  update(data) {
    const keys = Object.keys(data)
    const changedProps = keys.filter(
      key =>
        mutableProps.indexOf(key) > -1 &&
        data[key] !== undefined &&
        !Object.is(data[key], this[key])
    )
    changedProps.forEach(key => {
      this[key] = data[key]
    })
    /* istanbul ignore else */
    if (changedProps.length) {
      const shouldBeCalledSubscribers = Object.keys(this._subscribers)
        .filter(key => {
          if (this._subscribers[key].deps === undefined) return true
          const intersection = this._subscribers[key].deps.filter(
            dep => changedProps.indexOf(dep) > -1
          )
          return intersection.length
        })
        .map(key => this._subscribers[key])
      shouldBeCalledSubscribers.forEach(subscriber => {
        subscriber.subscriber(this)
      })
    }
  }

  subscribe(subscriber, deps) {
    const id = ++this._subscriberIdCounter
    Object.assign(this._subscribers, {
      [id]: {
        subscriber,
        // 传了，但是又不是数组，就默认位空数组避免报错，但是，永不调用。
        deps: deps === undefined || Array.isArray(deps) ? deps : []
      }
    })
    return id
  }

  unsubscribe(id) {
    /* istanbul ignore else */
    if (this._subscribers[id]) {
      delete this._subscribers[id]
    }
  }
}

export { Ssu }
